import { useScrollReveal } from "@/hooks/useScrollReveal";
import SectionTitle from "./SectionTitle";

const reasons = [
  {
    num: "01",
    title: "しっかり稼げる",
    desc: "日払い・週払いOK。高速道路警備なら日給最大20,000円。入社祝い金・各種手当も充実。あなたの生活をしっかり守ります。",
    icon: "ri-coins-line",
  },
  {
    num: "02",
    title: "未経験・ブランクOK",
    desc: "警備経験ゼロから始めたスタッフが多数活躍中。座学研修 → 実技研修 → OJT研修の3ステップで、先輩が丁寧に指導。研修センター完備で安心スタートできます。",
    icon: "ri-graduation-cap-line",
  },
  {
    num: "03",
    title: "チームで動くから安心",
    desc: "基本的に3名体制で現場に入ります。一人で立つのではなく、仲間と連携して動くスタイル。団結力がこの仕事の一番のやりがいです。",
    icon: "ri-team-line",
  },
];

export default function RecruitWhySection() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section className="bg-navy py-16 md:py-24" id="why-granstark">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto" ref={ref}>
        <div
          className={`transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <SectionTitle en="WHY GRANSTARK" ja="GRANSTARKで働く3つの理由" light centered />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {reasons.map((r) => (
              <div
                key={r.num}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 md:p-8 hover:bg-white/10 transition-all duration-300"
              >
                <div className="w-12 h-12 rounded-full bg-gold/20 flex items-center justify-center mb-5">
                  <span className="w-6 h-6 flex items-center justify-center text-gold">
                    <i className={`${r.icon} text-xl`}></i>
                  </span>
                </div>
                <span className="text-gold text-xs font-bold tracking-wider block mb-2">
                  {r.num}
                </span>
                <h3 className="text-xl font-bold text-white mb-3">{r.title}</h3>
                <p className="text-gray-300 text-sm leading-relaxed">{r.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}